<div class="drop-area-bg"></div>
<div class="drop-area-content">
  <div class="drop-area-container">
    <rt-icon size="large-xx" name="cloud-upload" />
    <rt-heading variant="heading large-xx">
      {{ 'app.candidate.drop_area.heading' | translate }}
    </rt-heading>
    <div class="subheading">
      {{ 'app.candidate.drop_area.subheading' | translate }}
    </div>
  </div>
</div>
